import React from 'react'
import { Modal } from 'react-bootstrap'
import styled from 'styled-components'
import { COLORS } from '../../styles/theme'
import whatsapp from '../../images/booth/whatsapp.png'

const StyledModal = styled(Modal)`
  .modal-content {
    box-shadow: 0px 4px 12px ${COLORS.lightGray1};
  }
  .modal-body {
    padding: 16px 32px;
    h6 {
      font-size: 22px;
      font-weight: 600;
    }
    .content {
      width: 100%;
      overflow-x: scroll;
      padding-bottom: 16px;
    }
    .divider {
      background: linear-gradient(270deg, #fe1e9a, #254dde);
      width: 100%;
      height: 4.5px;
      margin: 16px auto;
    }
    .contact {
      width: 100%;
      margin: 16px 0;
      p > svg {
        margin-right: 8px;
      }
      a {
        color: #505c7c;
        text-decoration: none;
      }
      h5 {
        text-decoration: underline;
        svg {
          margin-left: 8px;
        }
      }
    }
  }
`

export default function InfoModal({ title, description, content, infoOpen, setInfoOpen, agents }) {
  return (
    <StyledModal show={infoOpen} onHide={() => setInfoOpen(false)} size="lg" aria-labelledby="info-modal" centered>
      <Modal.Header closeButton>
        <Modal.Title id="info-modal" className="px-3">
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="content" dangerouslySetInnerHTML={{ __html: content }} />
        <div className="contact">
          <div>
            <h5 className="p-0 font-weight-bold">
              Contact Informations
              <img src={whatsapp} width="24px" className="ml-3" alt="whatsapp logo" />
            </h5>
          </div>
          {agents.map((agent, index) => (
            <div key={`Agent-${index + 1}`}>
              <p className="my-0 fw-bold">{agent.name}</p>
              {agent.phone && (
                <p className="my-1">
                  <svg width="20" height="20" viewBox="0 0 24 24">
                    <path
                      d="M20 22.621l-3.521-6.795c-.008.004-1.974.97-2.064 1.011-2.24 1.086-6.799-7.82-4.609-8.994l2.083-1.026-3.493-6.817-2.106 1.039c-7.202 3.755 4.233 25.982 11.6 22.615.121-.055 2.102-1.029 2.11-1.033z"
                      fill="#FFAD2C"
                    />
                  </svg>
                  <span className="ms-1">
                    <a href={`https://wa.me/${agent.phone}`} target="_blank" rel="noopener noreferrer">
                      {agent.phone}
                    </a>
                  </span>
                </p>
              )}
              {agent.email && (
                <p className="my-1">
                  <svg width="20" height="20" viewBox="0 0 24 24">
                    <path d="M0 3v18h24v-18h-24zm21.518 2l-9.518 7.713-9.518-7.713h19.036zm-19.518 14v-11.817l10 8.104 10-8.104v11.817h-20z" fill="#FFAD2C" />
                  </svg>
                  <span className="ms-1">
                    <a href={`mailto:${agent.email}`} target="_blank" rel="noopener noreferrer">
                      {agent.email}
                    </a>
                  </span>
                </p>
              )}
            </div>
          ))}
        </div>
      </Modal.Body>
    </StyledModal>
  )
}
